import React from 'react';
import PropTypes from 'prop-types';
import {Table} from 'semantic-ui-react';

const ValidationErrorTable = (props) => props.errors.length > 0 && (
    <Table celled padded>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>
            Platform
          </Table.HeaderCell>
          <Table.HeaderCell>
            Step ID
          </Table.HeaderCell>
          <Table.HeaderCell>
            Error
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
          { props.errors.map((vError, index) => (
              <Table.Row key={"validationError" + index}>
                <Table.Cell>
                  {vError.platform}
                </Table.Cell>
                <Table.Cell>
                  {vError.stepId}
                </Table.Cell>
                <Table.Cell>
                  {vError.message}
                </Table.Cell>
              </Table.Row>
            ))}
      </Table.Body>
    </Table>
);

ValidationErrorTable.propTypes = {
    errors: PropTypes.array.isRequired
};

export default ValidationErrorTable;



// WEBPACK FOOTER //
// ./public/components/break/ValidationErrorTable.jsx